import type { ChartFontSchemaType, ChartSchemaType } from '@vedalib/editor/lib/brand'
import { KEYS, setThemeVariable } from '@vedalib/editor/lib/brand'
import type { ChartElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { generateId } from '@vedalib/editor/lib/utils/id'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import type { FCDemoType } from '../../elements.types'
import Element from './ChartElement'

const primaryColor = setThemeVariable(KEYS.primaryColor)

const DEMO_LINE_VALUE: ChartElementValue = {
  type: 'line',
  description: true,
  x: 'X',
  y: 'Y',
  items: [
    { label: 'item 1', value: generateId(), val: 10 },
    { label: 'item 2', value: generateId(), val: 20 },
    { label: 'item 3', value: generateId(), val: 15 },
  ],
}

const DEMO_BAR_VALUE: ChartElementValue = {
  type: 'bar',
  description: true,
  x: 'X',
  y: 'Y',
  items: [
    { label: 'item 1', value: generateId(), val: 10, color: primaryColor },
    { label: 'item 2', value: generateId(), val: 20, color: primaryColor },
    { label: 'item 3', value: generateId(), val: 15, color: primaryColor },
  ],
}

const DEMO_PIE_VALUE: ChartElementValue = {
  type: 'pie',
  description: true,
  x: 'X',
  y: 'Y',
  items: [
    { label: 'item 1', value: generateId(), val: 10, color: primaryColor },
    { label: 'item 2', value: generateId(), val: 20, color: primaryColor },
    { label: 'item 3', value: generateId(), val: 15, color: primaryColor },
  ],
}

const LineChartDemo: FCDemoType<ChartSchemaType, ChartFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.chart.type}-demo`,
        type: CONFIG_ELEMENTS.chart.type,
        value: DEMO_LINE_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

const BarChartDemo: FCDemoType<ChartSchemaType, ChartFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.chart.type}-demo`,
        type: CONFIG_ELEMENTS.chart.type,
        value: DEMO_BAR_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)
const PieChartDemo: FCDemoType<ChartSchemaType, ChartFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.chart.type}-demo`,
        type: CONFIG_ELEMENTS.chart.type,
        value: DEMO_PIE_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)
export { LineChartDemo, BarChartDemo, PieChartDemo }
